import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {};
var defaultProps = {
  prefixCls: 'wui-anchor'
};
var AntdAnchorLink = (_dec = WebUI({
  name: "anchor",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AntdAnchorLink, _Component);

  var _super = _createSuper(AntdAnchorLink);

  function AntdAnchorLink(props) {
    _classCallCheck(this, AntdAnchorLink);

    return _super.call(this, props);
  }

  _createClass(AntdAnchorLink, [{
    key: "handleClick",
    value: function handleClick(value, e) {
      e.preventDefault(); // let { onscrollTo } = this.props
      // document.querySelector('#' + value.href).scrollIntoView(true)

      setTimeout(function () {
        document.querySelector('#' + value.href).scrollIntoView(true);
      }, 200);
      this.setState({
        active: true
      }); // onscrollTo()

      this.props.onSelect(value, e);
    }
  }, {
    key: "renderAntdAnchorLink",
    value: function renderAntdAnchorLink() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          href = _this$props.href,
          title = _this$props.title,
          children = _this$props.children,
          className = _this$props.className,
          target = _this$props.target,
          expanded = _this$props.expanded;
      var wrapperClassName = classNames("".concat(prefixCls, "-link"), _defineProperty({}, "".concat(prefixCls, "-link-active"), expanded), className);
      var titleClassName = classNames("".concat(prefixCls, "-link-title"), _defineProperty({}, "".concat(prefixCls, "-link-title-active"), expanded));
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassName
      }, /*#__PURE__*/React.createElement("a", {
        className: titleClassName,
        href: href,
        title: typeof title === 'string' ? title : '',
        target: target,
        onClick: this.handleClick.bind(this, {
          href: href,
          title: title
        })
      }, title), children);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderAntdAnchorLink();
    }
  }]);

  return AntdAnchorLink;
}(Component)) || _class);
AntdAnchorLink.propTypes = propTypes;
export default AntdAnchorLink;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-anchor/src/AntdAnchorLink.js